<template>
<div id="main">
  <div id="form">
    <div id="formSubstrate">
    <div id="plainFirst"/>
    <div id="reportSelection">
      <p id="reportChoise">Создать отчёт</p>
      <button v-if="true" v-bind:style="styles.buttonNM_1"
              v-on:click="downloadNM_1()">
        НМ-1
      </button>
      <button v-if="false" v-bind:style="styles.buttonReportCustom"
              v-on:click="setShosenReport('Свой отчёт','1.0')">
        {{choseCustomReport}}
      </button>
      <button v-if="false"  v-bind:style="styles.buttonReportReady"
              v-on:click="hideSHow_ReadyReportList()">
        {{choseReadyReport}}
      </button>
      <reportSelect  v-if="showReadyReport" />
    </div>
    <div id="chooseParametrs">
      <div id="columnSelection">
      <nestedSelect v-if="false" id="select_1"
                    title="Годы"
                    :nestedregs="values.yearOptions" 
                    v-bind:selected.sync="selected.year"
                    top="19%"
                    left="1%"
                    height="400px"/>
        <h4 id="selec_p_1">Столбцы:</h4>
        <select id="reportSelect" v-model="selected.column.name" @change="getValue(selected.column.name)">
          <option v-for="(select, index) in selects.columns"
                  :value="select">
                {{select}}
          </option>
        </select>
        <nestedSelect id="select_1"
                      title="Значения"
                      :nestedregs="values[selected.column.name]"
                      v-bind:selected.sync="selected.column.value"
                      top="19%"
                      left="9%"
                      height="400px"/>
      </div>
      <div id="rowSelection">
        <h4 id="selec_p">Строки:</h4>
        <select id="reportSelect" v-model="selected.row.name" @change="getValue(selected.row.name)">
          <option v-for="(select, index) in selects.rows.filter(row => row !== selected.column.name)" 
                  :value="select">
                {{select}}
          </option>
        </select>
        <nestedSelect id="select_1"
                      title="Значения"
                      :nestedregs="values[selected.row.name]"
                      v-bind:selected.sync="selected.row.value"
                      top="19%"
                      left="35%"
                      height="400px"/>
      </div>
      <div id="extraSelection">
        <p>Данные:</p>
        <nestedSelect id="select_1"
                      title="Значения"
                      :nestedregs="values.dataOptions"
                      v-bind:selected.sync="selected.extradata.data"
                      top="19%"
                      left="55%"
                      hieght="400px"/>
        <p>Форматирование:</p>
        <extraSelect id="select_1"
                      title="Значения"
                      :nestedregs="values.dataOptions"
                      v-bind:selected.sync="selected.formation.data"
                      top="19%"
                      left="71%"
                      hieght="400px"/>
      </div>
      <div id="buttonContainer">
        <button id="buttonOK2" v-on:click="getTable()">Применить</button>
      </div>
    </div>
    <div id="plainSecond"/>
  </div>
  </div>
    <div  v-if="showTable" id="view">
      <simpleDT :dataset="dataset"/>
    </div>
    <div v-if="showTable" id="downloading">
      <DownloadingBar :url_dwld="urlXLSXfile"/>
    </div>
</div>
</template>

<script>
import dataReg from './dataReg.js'
import nestedDataReg from './nestedDataReg.js'

import dataYears from './dataYears.js'
import dataset_ from './dataset2.js'
import dataset2 from './dataset_2.js'

import nestedSelect from './nestedSelect.vue'
import reportSelect from './reportSelect.vue'
import extraSelect from './extraSelect.vue'

// VIEW
import simpleDT from '../view/simpleDT_.vue'
// DOWNLOAD
import DownloadingBar from '../downloading/DownloadingBar.vue'

global.jQuery = require('jquery');
const axios = require('axios');

var $ = global.jQuery;

export default {
  name: 'Form',
  components: {nestedSelect, reportSelect, extraSelect, simpleDT, DownloadingBar},
  data: function() {
  	return {
      mainURL: 'http://46.101.109.44/api/v1/slice',
  		tableDataLoaded: false,
  		parametersSelectShow: false,
      years: dataYears.years, 
      dataset: '',
      selectedYear: '',
      reportYears: '',
      reportReg: '',
      regs: dataReg,
      selectedReg: '',
      nestedregs: nestedDataReg,
      showTable: false,
      choseCustomReport: 'создать свой',
      choseReadyReport: 'выбрать готовый',
      showReadyReport: false,
      urlXLSXfile: '',
      isToggled: false,
      reportMode: '',
      reportValue: '',
      stuff: {a: 1, b: 2},
      values: {
        'налоги': [
          {id: 1, name: "G"},
          {id: 2, name: "F"}
        ],
        'годы': '',
        'регионы': dataReg,
        'бюджет': ['федерального бюджета', 'консолидированного бюджета', 'доходы местных бюджетов'],
        dataOptions: [
          {"id": "charge", "name": "начисления"},
          {"id": "enrolled_split", "name": "разбиение поступлений"},
          /*{"id": "region_split", "name": "разбиение на регионы"}*/
        ],
        yearOptions: [
          {"id": "2016", "name": "2016"},
          {"id": "2017", "name": "2017"},
          {"id": "2018", "name": "2018"}
        ]
      },
      selected: {
        year: "",
        column: 
          {
            name: "",
            value: ""
          },
        row:
          {
            name: "",
            value: ""
          },
        extradata: {
          data: ""
        },
        formation: {
          data: {
            cbc: true,
            code: true
          }
        }
      },
      selects: {
        years: [
          2016,
          2017,
          2018
        ],
        columns: [
          'годы',
          'регионы',
          'федеральные округа',
          'страна',
          'налоги'
        ],
        rows: [
          'годы',
          'регионы',
          'федеральные округа',
          'страна',
          'налоги'
        ],
        extra: [
          'дополнительные фильтры',
          'данные',
          'формат'
        ]
      },
      styles: {
        buttonReportReady: {
          width: '180px',
          height: '30px',
          margin: '14px 20px 0px 0px',
          borderWidth: '1px',
          outline: 'none',
          borderRadius: '8px',
          fontSize: '12px',
          backgroundColor: '#f5f5f5',
          cursor: 'pointer',
        },
        buttonReportCustom: {
          width: '180px',
          height: '30px',
          margin: '14px 20px 0px 0px',
          borderWidth: '1px',
          outline: 'none',
          borderRadius: '8px',
          fontSize: '12px',
          backgroundColor: '#f5f5f5',
          cursor: 'pointer'
        },
        buttonNM_1: {
          width: '80px',
          height: '30px',
          margin: '14px 20px 0px 0px',
          borderWidth: '1px',
          outline: 'none',
          borderRadius: '8px',
          fontSize: '12px',
          backgroundColor: '#f5f5f5',
          cursor: 'pointer'
        }
      }
  	}
  },
  methods: {
    downloadNM_1: function() {
      this.getValue()
      this.getTable()
    },
    getValue: function(name) {

      let url_2 = 'http://46.101.109.44/api/v2/'

      if (name === 'регионы') url_2 = url_2 + 'regions'
      if (name === 'налоги') url_2 = url_2  + 'tax'
      if (name === 'федеральные округа') url_2 = url_2 + 'federal_areas'
      if (name === 'страна') url_2 = url_2 + 'country'
      if (name === 'годы') url_2 = url_2 + 'years'

      //let years = this.generate_server_arr(this.selected.year)
 
      $.get(url_2, data => {

        this.values[name] = data['response']
        let saved_name = this.selected.column.name
        this.selected.column.name = ''
        this.selected.column.name = saved_name
        console.log(data)
      })
    },
    getValueRow: function(name) {

      let url_2 = 'http://46.101.109.44/api/v2/'

      if (name === 'регионы') url_2 = url_2 + 'regions'
      if (name === 'налоги') url_2 = url_2  + 'tax'
      if (name === 'федеральные округа') url_2 = url_2 + 'federal_areas'
      if (name === 'страна') url_2 = url_2 + 'country'
      if (name === 'годы') url_2 = url_2 + 'years'

      if ( this.values['годы'] == '' ) {
        $.get(url_2, data => {

          this.values[name] = data['response']
          let saved_name = this.selected.column.name
          this.selected.row.name = ''
          this.selected.row.name = saved_name
          console.log(data)

        })
      }  else {

          let years = this.generate_server_arr(this.values['годы'])

          $.get(url_2, {year: years},data => {

          this.values[name] = data['response']
          let saved_name = this.selected.column.name
          this.selected.row.name = ''
          this.selected.row.name = saved_name
          console.log(data)

        })
      }

    },
    getTable: function() {

      const dict = {
        'налоги': 'tax',
        'регионы': 'regions',
        'федеральные округа': 'federal_areas',
        'страна': 'country',
        'годы': 'years'
      }

      let url_3 = 'http://46.101.109.44/api/v2/report'
      let charge_flag = false

      if (this.selected.extradata.data.indexOf('charge') > -1) charge_flag = true
      let enrolled_split_flag = false 
      if (this.selected.extradata.data.indexOf('enrolled_split') > -1) enrolled_split_flag = true
      let region_split_flag = false
      if (this.selected.extradata.data.indexOf('region_split') > -1) region_split_flag = true

      console.log('Years', this.selected.year)
      console.log('Col_val', this.selected.column.value)
      console.log('Row_val', this.selected.row.value)     

     // let years = this.generate_server_arr(this.selected.year)
      let col_value = this.generate_server_arr(this.values[this.selected.column.name])
      //let col_value = this.generate_server_arr(this.selected.column.value)
      let row_value = this.generate_server_arr(this.values[this.selected.row.name])
      //let row_value = this.generate_server_arr(this.selected.row.value)

      //console.log('Years-2', years)
      console.log('Col_val-2', col_value)
      console.log('Row_val-2', row_value) 

      $.get(url_3, 
        { year: '',
          column: dict[this.selected.column.name],
          col_value: col_value,
          row: dict[this.selected.row.name],
          row_value: row_value,
          charge: charge_flag, 
          enrolled_split: enrolled_split_flag,
          region_split: region_split_flag,
          cbc: this.selected.formation.data.cbc,
          code: this.selected.formation.data.code
        }, data => {
        console.log('DATA!!', data)
        this.values[name] = data['response']

        // this.urlXLSXfile = data.url
        // this.$store.commit('loadTableData', data.table)
        // this.$store.commit('setTableLoadStatus', false)
        // this.$store.commit('loadTableData', dataset)
        // this.$store.commit('setDownloadingURL', data.url)
        // this.$store.commit('setTableLoadStatus', true)

        this.dataset = data.table

        this.showTable = true

        this.urlXLSXfile = ''
        this.urlXLSXfile = data.url

        console.log(this.urlXLSXfile)
        console.log(data)
      })
    },
    testTableRender() {
      console.log('THIS', this.selected.formation.data)
      if (this.showTable) {
        this.dataset = dataset2
        this.showTable = false
        console.log('dataset2', dataset2)
        this.showTable = true
      } else {
        this.dataset = dataset_
        console.log('dataset_', dataset_)
        this.showTable = true
      }
    },
    getKey: function(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
  	getTableData: function() {
      let year = this.selectedYear
      let reg = this.getKey(dataReg, this.choseReg)
      let url = 'http://46.101.109.44/v1/slice'
      let url_2 = 'http://46.101.109.44/api/v2/report'
      let column = this.selected.column
      let row = this.selected.row
      let extra = this.selected.extradata
      console.log(column, row, extra)

      $.get(url_2, {category: {0: 'suka'}, year:'premium'})


      console.log(dataset.headersCellStyle)
      this.$store.commit('setTableLoadStatus', true)
      this.$store.commit('loadTableData', dataset)
      this.reportYears = this.selectedYear
      this.reportReg = this.choseReg
  	},
    toggle(id) {
      const index = this.opened.indexOf(id);

      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    addReg(name) {
      console.log(name)

      this.added = []
      this.added.push(name)

      this.choseReg = name
    },
    generate_server_arr(arr) {
      //return arr.map( (elem, index) => ({[index]: elem}) )
      let dict = {}
      if (typeof arr !== 'undefined') {
        arr.forEach( (elem, index) => dict[index] = elem)
        return dict 
      }
    },
    hideSHow_ReadyReportList() {
      this.showReadyReport = !this.showReadyReport
    },
    setShosenReport(mode, name){
      this.reportMode = mode
      this.reportValue = name
    },
    loadSettingMenu() {
      this.show.sliceSelection.sliceSelection = true
    }
  },
  computed: {
    checkTableStatus: function() {
      return this.$store.state.tableIsLoaded
    }
  },
  mounted() {
    console.log(this.dataset)
  }
}
</script>


<style>

#selectParameter {
  position: fixed;
  z-index: 100;

  background-color: white;

  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);

  width: 300px;
  height: 600px;

  top: 21%;
  left: 22%;

  padding: 0px 10px 0px 10px;
}

#reportLoadBar {
  left: 10%;
  display: inline-flex;
  border-color: #00569a;
  border-width: 1px;
}

#chooseParametrs {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: #FFF;
  border-width: solid;
}

#columnSelection {
  width: 365px;
  display: inline-flex;
  background: white;
}

h4#selec_p {
  font-size: 13px;
  margin: 25px 0px 0px 0px;
}

h4#selec_p_1 {
  font-size: 13px;
  margin: 25px 0px 10px 10px;
}

#rowSelection {
  width: 340px;
  display: inline-flex;
  background: white;
}

#extraSelection {
  width: 460px;
  display: inline-flex;
  background-color: #ffffff;
  margin-left: 10px;
}

#buttonContainer {
  width: auto;
  display: inline-flex;
  justify-content: flex-end;
}

#extraData {
  display: inline-flex;
}

#labelBudget {
  margin: 12px 0px 15px 0px;
  font-size: 12px;
}

input#a{
  margin-top: 15px;
}

input#b{
  margin-top: 15px;
}

input#c{
  margin-top: 15px;
}

#reportField {
  display: inline-flex;

  background-color: #f5f5f5;
  padding: 4px;

  height: 22px;
  width: 300px;

  margin: 16px 0px 15px 0px;
}

#extraDataSelect {
  font-size: 13px;
  margin-top: 16px;
  width: 450px;
}

#extraFormation {
  grid-column: 2;
  grid-row: 1/3;
  background-color: #e0e0e0;
  font-size: 13px;
  padding: 10px;
}

#tableDesc {
  display: flex;
  background-color: white;
}
 
#tableParag {
  margin: 12px 0px 15px 0px;
  font-size: 17px;
  font-weight: bold;
}

#row {
  display: flex;
  font-size: 10px
}

#row:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

#header {
  width: 200px;
  font-size: 15px;
  margin: 10px;
}

#body {
  font-size: 12px;
  margin: 10px;
}

#buttonOK4 {
  width: 80px;
  height: 25px;
  margin: 12px 0px 10px 70px;

  border-width: 0;
  outline: none;
  border-radius: 2px;

  font-size: 11px;
  font-weight: bold;
  color: white;

  background-color: #9e9e9e;

  cursor: pointer;
}

#select_1 {
  margin: 20px 0px 5px 10px;
}

#tableContainer {
  position: relative;
  border-style: solid;
  border-width: 1px;

  margin-bottom: 0px;
  height: 334px;
}
#choosenReport {
  margin: 0px 0px 0px 5px;
  color: black;

  font-size: 15px;
  font-weight: bold;
}

#choiceTable td:nth-child(1)  {
  background-color: #4d82cb;
  color: white;
  width: 25px;
  cursor: pointer;
  text-align: center;
}

#choiceTable td:nth-child(2)  {
  width: 195px;
}

#choiceTable td:nth-child(3)  {
  text-align: center;
  cursor: pointer;
}

#subRows td:nth-child(2)  {
  background-color: #f5f5f5;
}

#subRows td:nth-child(3)  {
  background-color: #f5f5f5;
}

#formSubstrate {
	height: 220px;

  display: inline-grid;
  grid-template-rows: 5% 25% 70px 2% 2% 0px;
}

#plainFirst {
	background-color: #00569a;
	border-radius: 10px 10px 0px 0px;
}

#reportSelection {
	display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: #4d82cb;
  color: #FFF;
}

#reportChoise {
	margin: 15px;
	font-size: 20px;
	font-weight: bold;
}

#reportSelect {
  font-size: 12px;
  height: 25px;
	margin: 23px 0px 0px 10px;
}

#sliceSelection {
	display: flex;
  flex-direction: row;
  justify-content: flex-start;
	background: #FFF;
	border-width: solid;
}

#sliceSelect {
	margin: 250px 60px 27px 100px;
}

#sliceChoise {
	margin: 24px;
	z-index: 100;
	font-size: 15px;
	font-weight: bold;
}

#parametersSelect {
	position: fixed;

	top: 20%;
	left: 13%;

	height: 80%;
	width: 60%;

	z-index: 100;
	background-color: white;
	border-style: solid;
	border-color: #00569a;
	box-shadow: 14px 15px 5px grey;
}

#codeCheckBox {
  margin: 29px 30px 10px 20px;
}

label {
  font-size: 15px;
  font-weight: bold;
  margin: 24px 0px 10px 20px;
}

#buttonParameters {
	width: 200px;
	height: 30px;
	margin: 19px 30px 10px 20px;


  border-radius: 20px;

	cursor: pointer;
}

#buttonOK {
  width: 80px;
  height: 30px;
  margin: 16px 30px 10px 20px;

  border-width: 0;
  outline: none;
  border-radius: 2px;

  font-weight: bold;
  color: white;
  background-color: #9e9e9e;

  cursor: pointer;
}

#buttonOK2 {
	width: 80px;
	height: 30px;
	margin: 19px 30px 10px 20px;

  border-width: 0;
  outline: none;
  border-radius: 2px;

	font-weight: bold;
	color: white;
	background-color: #00569a;

	cursor: pointer;
}

#buttonOK3 {
	width: 80px;
	height: 30px;
	margin: 39px 30px 10px 20px;

  border-width: 0;
  outline: none;
  border-radius: 2px;

	font-weight: bold;
	color: white;
	background-color: #9e9e9e;

	cursor: pointer;
}

#buttonReg {
  width: 180px;
  height: 30px;
  margin: 19px 20px 0px 0px;

  border-width: 1px;
  outline: none;
  border-radius: 8px;

  font-size: 12px;

  background-color: #f5f5f5;

  cursor: pointer;
}

#plainSecond {
  background-color: #fafafa;
}

#plainThird {
	background-color: white;
}

#fetchedDatadDescription {
	background-color: white;
  display: flex;
}

#fetchedDatadInfo {
	margin: 15px;
	margin: 12px 0px 0px 20px;
	font-size: 22px;
	font-weight: bold;
}
#fetchedDatadMetaInfo {
	font-size: 15px;
	color: grey;
	margin: 4px 0px 0px 20px;
}

#extraSelection p {
  margin: 24px 0px 5px 0px;
  font-size: 14px;
  font-weight: bold;
}

a {
  color: white;
  text-decoration: none;
}

#main::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#main::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#main::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#form::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#form::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#form::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#formSubstrate::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#formSubstrate::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#formSubstrate::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#plainFirst::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#plainFirst::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#plainFirst::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#reportSelection::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#reportSelection::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#reportSelection::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#reportChoise::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#reportChoise::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#reportChoise::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#chooseParametrs::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#chooseParametrs::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#chooseParametrs::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#columnSelection::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#columnSelection::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#columnSelection::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#selec_p::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#selec_p::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#selec_p::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#plainSecond::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#plainSecond::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#plainSecond::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#view::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#view::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#view::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#downloading::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#downloading::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#downloading::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}


button::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
button::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
button::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#select_1::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#select_1::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#select_1::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#rowSelection::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#rowSelection::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#rowSelection::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#extraSelection::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#extraSelection::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#extraSelection::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

html {
  overflow: hidden;
}


</style>
